var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTuition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0399 9.04721C3.8628 8.95007 3.86806 8.69388 4.049 8.60408L10.1765 5.56308C10.2446 5.52927 10.3244 5.52831 10.3933 5.56048L17.6431 8.9437C17.8394 9.03532 17.8342 9.31628 17.6346 9.40055L10.4283 12.4432C10.3579 12.4729 10.2778 12.4688 10.2108 12.4321L4.0399 9.04721Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1367 9.21631V14.8356",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23.25C17.5 24.5 16.25 24.5 16.25 24.5H3.75C3.75 24.5 2.5 24.5 2.5 23.25C2.5 22 3.75 18.25 10 18.25C16.25 18.25 17.5 22 17.5 23.25ZM16.25 23.245C16.2487 22.9375 16.0575 22.0125 15.21 21.165C14.395 20.35 12.8612 19.5 10 19.5C7.1375 19.5 5.605 20.35 4.79 21.165C3.9425 22.0125 3.7525 22.9375 3.75 23.245H16.25Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11V12.2857C7 14.3371 8.567 16 10.5 16C12.433 16 14 14.3371 14 12.2857V11.4286",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuition);
export default __webpack_public_path__ + "static/media/Tuition.5f1fcbf80671c49fbea56d93fc79bbc0.svg";
export { ForwardRef as ReactComponent };